module.exports = {
    "name": "Post CORONA",
    "children": [
        {
            "name": "Interfacial Transport Engineering",
            "children": [
                {
                    "name": "Air Management",
                    "children": [
                        {
                            "name": "Automatic Room Cleaning.",
                            "value": 10,
                            "description": "Walls and floors on which dust floats and that self-clean automatically using air flow.",
                            "image": "post_Automatic_cleaning_room_trim.jpg",
                            "card_id": "P1",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Breathable Architecture",
                            "value": 10,
                            "description": "Buildings that are designed to be self-ventilating",
                            "image": "post_Breathable_Architecture_trim.jpg",
                            "card_id": "P2",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#architecture",
                                        "#ventilation"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Air Quality",
                    "children": [
                        {
                            "name": "Artificial Wind",
                            "value": 10,
                            "description": "Artificial breeze to make people feel more comfortable, improving their mental health.",
                            "image": "post_Designed_Wind_trim.jpg",
                            "card_id": "P3",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Private Air Space",
                            "value": 10,
                            "description": "Air conditioning that keeps each person's space free of other people's odours in an enclosed environment.",
                            "image": "post_Private_Air_Space_trim.jpg",
                            "card_id": "P4",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#shelter",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Floor Air Conditioning",
                            "value": 10,
                            "description": "Air which blows up gently from the floor, like underfloor heating.",
                            "image": "post_Floor_Air_Conditioner_trim.jpg",
                            "card_id": "P5",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Cat Allergen Absorption Robot",
                            "value": 10,
                            "description": "Autonomous 'cat' robot that absorbs and collects cat allergens.",
                            "image": "post_Cat_allergen_adsorption_robot_trim.jpg",
                            "card_id": "P49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Against Pollinosis Architecture",
                            "value": 10,
                            "description": "House where all the interiors inhale pollen, enabling the inhabitants to avoid allergic symptoms.",
                            "image": "post_Against_Pollinosis_Architecture_trim.jpg",
                            "card_id": "P50",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Water Flow Management",
                    "children": [
                        {
                            "name": "Microplastics Catcher",
                            "value": 10,
                            "description": "System creating a physical flow of water to collect microplastics in the ocean.",
                            "image": "post_Micro_Plastics_Catcher_trim.jpg",
                            "card_id": "P6",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#water",
                                        "#ocean",
                                        "#micro_plastics"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Micro Components and Systems",
            "children": [
                {
                    "name": "Utilizing body fluids data",
                    "children": [
                        {
                            "name": "Smart Patch Watch",
                            "value": 10,
                            "description": "Smart watch integrated with a microneedle patch to collect data on the physical condition of the body.",
                            "image": "post_Smart_Patch_Watch_trim.jpg",
                            "card_id": "P7",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#watch",
                                        "#well_being",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Health Check Cosmetics",
                            "value": 10,
                            "description": "Patch that can be used for eyeshadow, for instance, that also collects data on the condition of the skin.",
                            "image": "post_Health_Check_Cosmetic_trim.jpg",
                            "card_id": "P8",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#cosmetic",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Emotion Detection Patch",
                            "value": 10,
                            "description": "Microneedle patch that can detect emotions from data on body fluids.",
                            "image": "post_Emotion_detection_Patch_trim.jpg",
                            "card_id": "P9",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#mental_health",
                                        "#emotion"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "New Use for a Microneedle",
                    "children": [
                        {
                            "name": "Microneedle Patch for Diabetes",
                            "value": 10,
                            "description": "Microneedle patch that painlessly replenishes diabetics with insulin to lower blood sugar levels.",
                            "image": "post_Micro-needle_for_diabetes_trim.jpg",
                            "card_id": "P10",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#painless",
                                        "#diabetes"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Microneedle Patch Sheet",
                            "value": 10,
                            "description": "Sheet of microneedle patches from which individual personalized medicine dosage can be cut.",
                            "image": "post_Micro_needle sheet_trim.jpg",
                            "card_id": "P11",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#habit",
                                        "#dosage"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Microneedle Perfume Patch",
                            "value": 10,
                            "description": "Microneedle patch with essential oils with a pleasant smell that can penetrate the skin.",
                            "image": "post_Micro_needle_perfume_trim.jpg",
                            "card_id": "P12",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#fashion",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Microneedle Tattoo Patch",
                            "value": 10,
                            "description": "Microneedle patch which can be used as a temporary fashion tattoo.",
                            "image": "post_Micto_Needle_Tattoo_trim.jpg",
                            "card_id": "P13",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#fashion",
                                        "#tatoo"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Microneedle Patch for Plants",
                            "value": 10,
                            "description": "Microneedle patch for plants with which the plant's condition can be managed.",
                            "image": "post_Micro_needle_for_Plants_trim.jpg",
                            "card_id": "P14",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#plant",
                                        "#tree",
                                        "#health"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Medical Biotechnology",
            "children": [
                {
                    "name": "Health Care at Home",
                    "children": [
                        {
                            "name": "Health Forecast",
                            "value": 10,
                            "description": "Health forecast that measures capillary data and predicts the status of an individual's health.",
                            "image": "post_Health_Forecast_trim.jpg",
                            "card_id": "P15",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#daily_routine",
                                        "#data"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Breath Health Scan",
                            "value": 10,
                            "description": "Health scan that analyses an individual's breath to measure its chemical composition.",
                            "image": "post_Breath_Health_Scan_trim.jpg",
                            "card_id": "P23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#breath",
                                        "#air",
                                        "#health_care"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Speech-free Health Measurement",
                    "children": [
                        {
                            "name": "Animal Capillary Health Checker",
                            "value": 10,
                            "description": "Measuring instrument to assess an animal's capillary health.",
                            "image": "post_Animal_Capillary_Health_Checker_trim.jpg",
                            "card_id": "P16",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#animal",
                                        "#health",
                                        "#remote"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Health Literacy",
                    "children": [
                        {
                            "name": "Self-health Check Training",
                            "value": 10,
                            "description": "Training for self-health checking, teaching people about health conditions from subjective symptoms.",
                            "image": "post_Self_Health_Check_Training_trim.jpg",
                            "card_id": "P17",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#daily_routines"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "New Unit of Capillary Health",
                            "value": 10,
                            "description": "Unit of blood flow that communicates details of the health of blood vessels (e.g. cc/s, viscosity).",
                            "image": "post_New_unit_of_Capillary_Health_trim.jpg",
                            "card_id": "P18",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#communication"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "New Words for Capillary Health",
                            "value": 10,
                            "description": "New words to describe an individual's condition of health and raise self-awareness.(e.g. capillary beauty)",
                            "image": "post_New_words_of_Capillary_Health_trim.jpg",
                            "card_id": "P19",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#habit",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Multipurpose Use of Capillary Data",
                    "children": [
                        {
                            "name": "Capillary Monitoring for Diabetes",
                            "value": 10,
                            "description": "Capillary monitoring system to identify diabetes.",
                            "image": "post_Capillary_Monitoring_for_diabetes_trim.jpg",
                            "card_id": "P20",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#diabetes",
                                        "#data",
                                        "#painless"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Capillary Talk",
                            "value": 10,
                            "description": "Communication tool that presents capillaries visually as cartoon characters.",
                            "image": "post_Capillary_Talk_trim.jpg",
                            "card_id": "P21",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#data_visualisation",
                                        "#relationship",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Capillary Measurement Method",
                    "children": [
                        {
                            "name": "Capillary-measuring Spectacles",
                            "value": 10,
                            "description": "Spectacles (eyeglasses) that measure the condition of fundus capillaries and store health data.",
                            "image": "post_Eyeglasses_Measuring_Capillaries_trim.jpg",
                            "card_id": "P22",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#data",
                                        "#health_care",
                                        "#wearable"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Ultrafast Optics",
            "children": [
                {
                    "name": "Health Care at Home",
                    "children": [
                        {
                            "name": "Health Forecast",
                            "value": 10,
                            "description": "Health forecast that measures capillary data and predicts the status of an individual's health.",
                            "image": "post_Health_Forecast_trim.jpg",
                            "card_id": "P15",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#daily_routine",
                                        "#data"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Breath Health Scan",
                            "value": 10,
                            "description": "Health scan that analyses an individual's breath to measure its chemical composition.",
                            "image": "post_Breath_Health_Scan_trim.jpg",
                            "card_id": "P23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#breath",
                                        "#air",
                                        "#health_care"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Detecting Invisible Danger",
                    "children": [
                        {
                            "name": "Air Pollution Monitor",
                            "value": 10,
                            "description": "Air pollution monitor (NOx/Nitrogen oxides and SOx/Sulfur oxides).",
                            "image": "post_Air_pollution_monitoring_trim.jpg",
                            "card_id": "P24",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#environment",
                                        "#air",
                                        "#monitoring"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Carbon Monoxide Detector",
                            "value": 10,
                            "description": "Instrument that detects and measures poisonous carbon monoxide in a space (e.g. room / car).",
                            "image": "post_Carbon_Monoxide_Poisoning_Detector_trim.jpg",
                            "card_id": "P25",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#danger"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Exhaust Gas Monitor",
                            "value": 10,
                            "description": "Instrument attached to a vehicle that monitors and measures the quality of its exhaust gas.",
                            "image": "post_Exhaust_Gas_Monitoring_trim.jpg",
                            "card_id": "P26",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#climate_change",
                                        "#air",
                                        "#detection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Food Poisoning Detector",
                            "value": 10,
                            "description": "Sensor that detects the bacteria that cause food poisoning.",
                            "image": "post_Food_Poisoning_Detector_trim.jpg",
                            "card_id": "P27",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#food",
                                        "#detection",
                                        "#danger"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Detecting Invisible/Useful Information",
                    "children": [
                        {
                            "name": "Plant Chemicals Communication Detector",
                            "value": 10,
                            "description": "Flowerpot that detects chemicals being released, to enable beneficial communication between plants and the air.",
                            "image": "post_Plants_Communication_Detector_trim.jpg",
                            "card_id": "P28",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#biology"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Pheromone Detector",
                            "value": 10,
                            "description": "Detects pheromones from endangered breeds to help them reproduce properly.",
                            "image": "post_Pheromone_Detector_trim.jpg",
                            "card_id": "P29",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#biology"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Isotope Meteorology",
            "children": [
                {
                    "name": "Crowdsourced Visualization",
                    "children": [
                        {
                            "name": "Shelter Guide",
                            "value": 10,
                            "description": "App that tracks evacuation movement and predicts shelter capacity and availability.",
                            "image": "post_Shelter_guide_trim.jpg",
                            "card_id": "P30",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#shelter",
                                        "#data_visualisation",
                                        "#congestion"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Traffic & CO2 Impact Map",
                            "value": 10,
                            "description": "Citizen science platform that visualizes and displays levels of traffic congestion and CO2 emission.",
                            "image": "post_Traffic&CO2_Impact_Map_trim.jpg",
                            "card_id": "P31",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#congestion",
                                        "#data_visualisation",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Environmental Impact Literacy",
                    "children": [
                        {
                            "name": "CO2 Tag",
                            "value": 10,
                            "description": "Tag that displays the amount of CO2 emitted in the process of producing a product.",
                            "image": "post_CO2_Tag_trim.jpg",
                            "card_id": "P32",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#communication",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Utilization of Environmental Data",
                    "children": [
                        {
                            "name": "Food Waste Reduction Tool",
                            "value": 10,
                            "description": "Food demand forecast that uses environmental data analysis to reduce food waste.",
                            "image": "post_Food_Loss_Cutter_trim.jpg",
                            "card_id": "P33",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#food",
                                        "#prediction",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Utilization of Historic Data",
                    "children": [
                        {
                            "name": "Future Disaster Calendar",
                            "value": 10,
                            "description": "Calendar predicting future disasters from data on the time / frequency of earlier disasters.",
                            "image": "post_Future_Disaster_Calendar_trim.jpg",
                            "card_id": "P34",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#prediction",
                                        "#disaster",
                                        "#climate_change"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Ancient Language Translation App",
                            "value": 10,
                            "description": "App that translates ancient documents into modern languages.",
                            "image": "post_Ancient_Language_Translator_trim.jpg",
                            "card_id": "P35",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#climate_change",
                                        "#linguistics",
                                        "#history"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Management of Project",
            "children": [
                {
                    "name": "Enabling Physical Presence",
                    "children": [
                        {
                            "name": "Virtual CEO",
                            "value": 10,
                            "description": "Android that can reproduce the physical presence of a CEO.",
                            "image": "post_Virtual_CEO_trim.jpg",
                            "card_id": "P36",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#virtual",
                                        "#communication",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Virtual Security Guard",
                            "value": 10,
                            "description": "Visible virtual security guard which detects the presence of people and prevents crime.",
                            "image": "post_Virtual_Security_Guard_trim.jpg",
                            "card_id": "P37",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#virtual",
                                        "#crime_prevention",
                                        "#presence"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Urban Energy Engineering",
            "children": [
                {
                    "name": "Active Creation of Clean Air",
                    "children": [
                        {
                            "name": "Oxygen Chewing Gum",
                            "value": 10,
                            "description": "Chewing gum that produces oxygen when chewed.",
                            "image": "post_Oxygen_Gum_trim.jpg",
                            "card_id": "P38",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#breath",
                                        "#health"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Human Centered Urban Informatics",
            "children": [
                {
                    "name": "New Ways of Working",
                    "children": [
                        {
                            "name": "New Working Time Definition",
                            "value": 10,
                            "description": "New definition of the working / non-working day, moving from 'weekday/weekend', to 'online day/offline day'.",
                            "image": "post_New_Working_Days_trim.jpg",
                            "card_id": "P39",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#mental_health",
                                        "#well_being",
                                        "#habit"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Visualization of Hope",
                    "children": [
                        {
                            "name": "Guide to a Better Future",
                            "value": 10,
                            "description": "Platform that shows the achievement of SDGs by obtaining data from the city.",
                            "image": "post_Guide_of_Better_Future_trim.jpg",
                            "card_id": "P40",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#public",
                                        "#well_being",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "AI x Visualization",
                    "children": [
                        {
                            "name": "Hope Concierge",
                            "value": 10,
                            "description": "App which advises which of people's hopes are achievable and closest to their ideal life.",
                            "image": "post_Hope_Concierge_trim.jpg",
                            "card_id": "P41",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#mental_health",
                                        "#well_being",
                                        "#daily_routine"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Interactive visual intelligence",
            "children": [
                {
                    "name": "Visual Experience",
                    "children": [
                        {
                            "name": "Experience Monitor",
                            "value": 10,
                            "description": "VR monitor that visually guards the elderly and guarantees their safety.",
                            "image": "post_Experience_Monitor_trim.jpg",
                            "card_id": "P42",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#privacy",
                                        "#virtual",
                                        "#remote"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Online Communication Manager",
                            "value": 10,
                            "description": "App that automatically adjusts the viewpoint in online images to match that of the viewer.",
                            "image": "post_Online_Communication_Manager_trim.jpg",
                            "card_id": "P43",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#remote",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Craftsperson's Viewpoint Archive",
                            "value": 10,
                            "description": "Archive offering the chance to experience visually how a traditional craftsperson sees their working process.",
                            "image": "post_Artisans_Line_of_Sight_Archive_trim.jpg",
                            "card_id": "P44",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#habit",
                                        "#virtual"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Tactile Map Guide",
                            "value": 10,
                            "description": "Map with ultrasonic tactile feedback for visually impaired people.",
                            "image": "post_Tactile_Map_Guide_trim.jpg",
                            "card_id": "P46",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#interface",
                                        "#tactile",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Non-tactile Communication",
                    "children": [
                        {
                            "name": "Wink Catcher",
                            "value": 10,
                            "description": "Accessory attracting visual attention to identify those who are interested (events/crime prevention).",
                            "image": "post_Wink Catcher_trim.jpg",
                            "card_id": "P45",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#crime_prevention",
                                        "#gathering",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Visual Media Engineering",
            "children": [
                {
                    "name": "Visual Experience",
                    "children": [
                        {
                            "name": "Experience Monitor",
                            "value": 10,
                            "description": "VR monitor that visually guards the elderly and guarantees their safety.",
                            "image": "post_Experience_Monitor_trim.jpg",
                            "card_id": "P42",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#privacy",
                                        "#virtual",
                                        "#remote"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Online Communication Manager",
                            "value": 10,
                            "description": "App that automatically adjusts the viewpoint in online images to match that of the viewer.",
                            "image": "post_Online_Communication_Manager_trim.jpg",
                            "card_id": "P43",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#remote",
                                        "#presence"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Craftsperson's Viewpoint Archive",
                            "value": 10,
                            "description": "Archive offering the chance to experience visually how a traditional craftsperson sees their working process.",
                            "image": "post_Artisans_Line_of_Sight_Archive_trim.jpg",
                            "card_id": "P44",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#habit",
                                        "#virtual"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Tactile Map Guide",
                            "value": 10,
                            "description": "Map with ultrasonic tactile feedback for visually impaired people.",
                            "image": "post_Tactile_Map_Guide_trim.jpg",
                            "card_id": "P46",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#interface",
                                        "#tactile",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Design of Architecture",
            "children": [
                {
                    "name": "Mental Health Care at home",
                    "children": [
                        {
                            "name": "Mental Care Room",
                            "value": 10,
                            "description": "Interior space that changes colour according to brain waves, helping to stabilize the mind.",
                            "image": "post_Mental_Care_Room_trim.jpg",
                            "card_id": "P47",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#room",
                                        "#well_being",
                                        "#architecture"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "Community Management",
                    "children": [
                        {
                            "name": "Harvest Sharing App",
                            "value": 10,
                            "description": "App that identifies people to share surplus vegetables harvested from the garden or allotment.",
                            "image": "post_Harvest_Sharing_App_trim.jpg",
                            "card_id": "P48",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#well_being",
                                        "#community"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "Biophysical Engineering",
            "children": [
                {
                    "name": "Air Quality",
                    "children": [
                        {
                            "name": "Artificial Wind",
                            "value": 10,
                            "description": "Artificial breeze to make people feel more comfortable, improving their mental health.",
                            "image": "post_Designed_Wind_trim.jpg",
                            "card_id": "P3",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#mental_health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Private Air Space",
                            "value": 10,
                            "description": "Air conditioning that keeps each person's space free of other people's odours in an enclosed environment.",
                            "image": "post_Private_Air_Space_trim.jpg",
                            "card_id": "P4",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#shelter",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Floor Air Conditioning",
                            "value": 10,
                            "description": "Air which blows up gently from the floor, like underfloor heating.",
                            "image": "post_Floor_Air_Conditioner_trim.jpg",
                            "card_id": "P5",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#wind",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Cat Allergen Absorption Robot",
                            "value": 10,
                            "description": "Autonomous 'cat' robot that absorbs and collects cat allergens.",
                            "image": "post_Cat_allergen_adsorption_robot_trim.jpg",
                            "card_id": "P49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "Against Pollinosis Architecture",
                            "value": 10,
                            "description": "House where all the interiors inhale pollen, enabling the inhabitants to avoid allergic symptoms.",
                            "image": "post_Against_Pollinosis_Architecture_trim.jpg",
                            "card_id": "P50",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#cleaning",
                                        "#room",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};